<template>
  <div>
    <a-row>
      <a-col :span="24">
        <h1>Review detail</h1>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-spin :spinning="loading">
          <review-form :initial="initial" v-if="!loading" :editable="canEdit" />
        </a-spin>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import ReviewForm from '@/components/companies/Review/ReviewForm.vue'
import { useRouter } from 'vue-router'
import { notification } from 'ant-design-vue'
import { prepareDataFromServer } from '@/components/companies/Review/dataAdapter'
import useError from '@/composables/useError'

export default {
  components: {
    ReviewForm,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const loading = ref(true)
    const raiseError = useError()
    const initial = ref()
    const store = useStore()
    const hasPermission = store.getters.hasPermission
    const canEdit = hasPermission(['update-review'])

    onMounted(async () => {
      try {
        const response = await store.dispatch('companies/fetchReview', {
          id: route.params.id,
        })
        initial.value = prepareDataFromServer(response.data.data)
        loading.value = false
      } catch (e) {
        raiseError(404, 'Review not found')
      }
    })

    return {
      initial,
      loading,
      canEdit,
    }
  },
}
</script>

<style></style>
